import React from 'react';
import {Provider} from "react-redux";
import configure from "../../store/configure";
import JoinCompleteContainer from "./container/JoinCompleteContainer";

const JoinCompletePage = () => {
    return (
        <Provider store={configure}>
            <JoinCompleteContainer/>
        </Provider>
    )
};

export default JoinCompletePage;
